import { config } from '../../Config';

const GetRecentPublications = async (userId, category, subcategory) => {
    const url = config.getRecentPublications;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: userId,
                category: category,
                subcategory: subcategory
            })
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch recent publications: ${response.statusText}`);
        }

        const data = await response.json();
        return data.recentPublications || [];
    } catch (error) {
        // console.error('Error fetching recent publications:', error);
        return [];
    }
};

export default GetRecentPublications;
